import React, { useEffect, useRef, useState } from 'react';
import { getBetDescription } from '../data/utils/getBetDescription';
import { scrollToTarget } from '../data/utils/scrollToTarget';
import { getBetDescriptionBetSelector } from '../data/utils/getBetDescriptionBetSelector';
import { classIf } from '../data/utils/classIf';

function BetSelector(props) {
    const [expanded, setExpanded] = useState(false);

    function toggleExpand() {
        setExpanded(!expanded);
        if (expanded) {
            setTimeout(() => {
                if (navbar.current) {
                    const selected = navbar.current.querySelector('.selected');
                    scrollToTarget(navbar.current, selected);
                }
            }, 200);
        }
    }

    const navbar = useRef(null);
    useEffect(() => {
        if (navbar.current) {
            const selected = navbar.current.querySelector('.selected');
            if (navbar.current.firstElementChild !== selected) {
                navbar.current.scrollLeft = selected.getBoundingClientRect().left;
            }
        }
    }, []);

    return (
        <nav id="betselector" className="nav-filters-wrapper">
            <div className={"nav-filters" + classIf(expanded, 'expanded')} ref={navbar}>
                {props.bets.map(bet => {
                    function handleClick(e) {
                        props.changeBet(bet);
                        if (expanded) {
                            setExpanded(!expanded);
                            setTimeout(() => {
                                if (navbar.current) {
                                    scrollToTarget(navbar.current, e.target);
                                }
                            }, 200);
                        }
                    }
                    let selected = false;
                    if (props.bet.handicap !== 0) {
                        selected = bet.id === props.bet.id && bet.handicap == props.bet.handicap;
                    }
                    else if (bet.uniqueId !== undefined){
                        selected = bet.uniqueId === props.bet.uniqueId || bet.id === props.bet.id;
                    } 
                    else {
                        selected = bet.id === props.bet.id;
                    }

                    // If the main line is set, then show the description without handicap (the bet corresponding to the main line will be shown at the bottom)
                    let desc = bet.descNoHandicap;
                    if (bet.mainLine === 0) {
                        if (props.isLive === true) {
                            desc = getBetDescriptionBetSelector(bet, true);
                        } else {
                            desc = getBetDescription(bet, false);
                        }
                    }
                    
                    return <div key={bet?.uniqueId ?? bet.id} className={"nav-filter-item" + classIf(selected, 'selected')} onClick={handleClick}>{desc}</div>
                })}
                {expanded &&
                    <div className="nav-filters-close-button" onClick={toggleExpand}>
                        <i className="far fa-times-circle"></i>
                    </div>
                }
            </div>
            {props.bets.length > 3 &&
                <div className="nav-filters-expand-button" onClick={toggleExpand}>
                    <i className="fa fa-angle-down"></i>
                </div>
            }
        </nav>
    );
}

export default BetSelector;